import React from "react";
import { Route } from "react-router-dom";
// import Home from "./../Home/Home";
import About from "../about";
import Dashboard from "../Dashboard/Dashboard";
import Fuel from "../Fuel/Fuel";
import Driving from "../Driving/Driving";
import Gas from "../Gas/Gas";
import Temp from "../Temp/Temp";
import Scan from "../Scan/Scan";
import MenuAppBar from "../MenuAppBar/MenuAppBar";
import TemporaryDrawer from "../TemporaryDrawer/TemporaryDrawer";
import DataLoader from "./../../components/DataLoader/DataLoader";
import LlantasPro from "./../../containers/LlantasPro/LlantasPro";
import Home from "../../containers/Home/Home";
import "./app.css";

export default () => (
  <div className="app">
    <MenuAppBar />
    <TemporaryDrawer />
    <DataLoader />
    <main>
      <Route exact path="/" component={Home} />
      <Route exact path="/about-us" component={About} />
      <Route exact path="/dashboard" component={Dashboard} />
      <Route exact path="/fuel" component={Fuel} />
      <Route exact path="/gas" component={Gas} />
      <Route exact path="/driving" component={Driving} />
      <Route exact path="/temp" component={Temp} />
      <Route exact path="/scan" component={Scan} />
      <Route exact path="/llantaspro" component={LlantasPro} />
    </main>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/app/index.js